// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","boxWrap":"_2q-GoS8FbIB2fkhuWNnR49","hasUserContent":"_36bmNCFpLMfNnfkqtxmDq_"};